import styled, { css } from 'styled-components';

interface ListItemModifierProps {
  isHidden?: boolean;
  isFirst?: boolean;
}

export const ListItemModifier = styled.div<ListItemModifierProps>`
  ${({ isFirst }) =>
    isFirst &&
    css`
      margin-top: 60px;
      > div > div:first-of-type span {
        font-weight: bold;
      }
    `}
  ${({ isHidden }) =>
    isHidden &&
    css`
      display: none;
      visibility: hidden;
    `}
text-transform: lowercase;
  > div {
    width: 100%;
    > div:first-of-type {
      margin-left: 0;
    }
  }

  &:last-of-type {
    > div:last-of-type {
      display: none;
    }
  }
`;

export const ButtonModifier = styled.div`
  button {
    flex-direction: row-reverse;
    padding: 16px 0;
    margin-top: 12px;
  }
`;
